import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

import { OrgLevelSearch } from "~/admin/agBytes/components/org-level-search";
import { Section, SubSection } from "~/core";
import { fetchDropdownData } from "~/core/dropdowns/actions";
import { AppHelpers, HierarchyAPI } from "@ai360/core";

import _ from "lodash";
import { getDropdowns } from "./../../selectors";

const PROPS_ORG_LEVEL_PARENT = "orgLevelParents";
const DELIMITER = " > ";

export class HierarchyFilter extends Component {
    static propTypes = {
        selectedCompanyUserGuid: PropTypes.string,
        filterToLastUsedLocation: PropTypes.bool,
        fetchDropdownData: PropTypes.func,
        needs: PropTypes.func,
        onFilterChange: PropTypes.func,
        placeholderText: PropTypes.string,
    };

    static defaultProps = {
        filterToLastUsedLocation: true,
    };

    static ORG_LEVEL = "orgLevel";

    constructor(props) {
        super(props);
        this.state = {
            [HierarchyFilter.ORG_LEVEL]: [],
        };
    }

    componentDidUpdate(prevProps) {
        if (
            !_.isEqual(this.props.selectedCompanyUserGuid, prevProps.selectedCompanyUserGuid) ||
            this.props.filterToLastUsedLocation !== prevProps.filterToLastUsedLocation
        ) {
            this.fetchDropdownData(
                this.props.selectedCompanyUserGuid,
                this.props.filterToLastUsedLocation
            );
        }

        if (
            !_.isEqual(this.props[HierarchyFilter.ORG_LEVEL], prevProps[HierarchyFilter.ORG_LEVEL])
        ) {
            const parsed = AppHelpers.parseOrgLevelList(
                this.props[HierarchyFilter.ORG_LEVEL],
                PROPS_ORG_LEVEL_PARENT,
                DELIMITER
            );
            if (!_.isEqual(parsed, this.state[HierarchyFilter.ORG_LEVEL])) {
                this.setState({ [HierarchyFilter.ORG_LEVEL]: parsed });
            }
        }
    }

    componentDidMount() {
        this.fetchDropdownData(
            this.props.selectedCompanyUserGuid,
            this.props.filterToLastUsedLocation
        );
    }

    fetchDropdownData(selectedCompanyUserGuid, filterToLastUsedLocation) {
        const url = filterToLastUsedLocation
            ? HierarchyAPI.REQUEST_ORG_LEVEL_WITH_PARENTS
            : HierarchyAPI.REQUEST_ORG_LEVEL_WITH_PARENTS_UNFILTERED;
        this.props.needs([
            this.props.fetchDropdownData({
                [HierarchyFilter.ORG_LEVEL]: {
                    url,
                    model: selectedCompanyUserGuid,
                },
            }),
        ]);
    }

    render() {
        return (
            <Section className="hierarchy-filter-container">
                <SubSection>
                    <OrgLevelSearch
                        itemList={this.state[HierarchyFilter.ORG_LEVEL]}
                        onSelection={this.props.onFilterChange}
                        placeholderText={this.props.placeholderText}
                    />
                </SubSection>
            </Section>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    fetchDropdownData: (payload) => dispatch(fetchDropdownData(payload)),
});

const mapStateToProps = (state) => ({
    ...getDropdowns([HierarchyFilter.ORG_LEVEL], state),
});

export default connect(mapStateToProps, mapDispatchToProps)(HierarchyFilter);
